import React from 'react';

// Old links to the retired meeting pages (bookmarks, e-mails) land here instead (config/features LEGACY_MEETINGS)
function RetiredMeetingsPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6" data-testid="meetings-retired">
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 max-w-md text-center">
        <h1 className="text-xl font-bold text-gray-900 mb-2">AI intake meetings have been retired</h1>
        <p className="text-sm text-gray-600 mb-6">Hiring managers now create jobs with Jessica from My Requisitions. Existing jobs still open from the View icon in Jobs.</p>
        <button onClick={() => window.history.back()} className="px-5 py-2.5 rounded-xl bg-brand-blue text-white text-sm font-bold">Go back</button>
      </div>
    </div>
  );
}

export default RetiredMeetingsPage;
